import { render, staticRenderFns } from "./BlogPostsSidebarCategory.vue?vue&type=template&id=2de50351&scoped=true&"
import script from "./BlogPostsSidebarCategory.vue?vue&type=script&lang=js&"
export * from "./BlogPostsSidebarCategory.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsSidebarCategory.vue?vue&type=style&index=0&id=2de50351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de50351",
  null
  
)

export default component.exports